<template>
  <v-card class="px-3 pb-3">
    <v-card-title class="px-0">
      <v-btn color="primary ml-0" large @click="stockDialog = true">
        View Stock
      </v-btn>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-select
        class="filterSelect py-2"
        v-model="selectedStatus"
        label="Filter By Status"
        :items="statusType"
        item-text="status"
        item-value="value"
        dense
        outlined
        hide-details
      ></v-select>
      <v-text-field
        v-model="search"
        prepend-inner-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
        solo
        clearable
      ></v-text-field>
    </v-card-title>
    <div style="height: 100%">
      <v-progress-linear
        v-if="tableLoading"
        indeterminate
        color="primary"
      ></v-progress-linear>
      <ag-grid-vue
        :style="{ width, height }"
        domLayout="autoHeight"
        class="ag-theme-balham mb-4"
        :gridOptions="gridOptions"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="filteredHardwareOrders"
        pagination
        :paginationPageSize="10"
        :frameworkComponents="frameworkComponents"
        @grid-ready="onFirstDataRendered"
      ></ag-grid-vue>
    </div>
    <mia-stock
      :stockDialog="stockDialog"
      @close="stockDialog = false"
    ></mia-stock>
    <hardware-details
      ref="details"
      v-if="hardwareDialog"
      :hardwareDialog="hardwareDialog"
      @close="hardwareDialog = false"
    ></hardware-details>
    <OrderServices
      :visible="orderServicesDialog"
      @close="resetOrderServices"
      :order="orderServicesData"
      :ubDealerID="UBID"
      v-if="$ld.flags && $ld.flags.vonexAdminUbServices"
    />
  </v-card>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapOrderActions } = createNamespacedHelpers(`orders`);
import { mapGetters } from 'vuex';
import { AgGridVue } from 'ag-grid-vue';
import HardwareDetails from '@/components/mia/hardware-details';
import MiaStock from '@/components/mia/mia-stock';
import TableButtons from '@/components/mia/table-buttons';
import OrderServices from '@/components/mia/order-services';
import LoaderDialog from '@/components/common/LoaderDialog';

export default {
  name: 'HardwareOrders',
  components: {
    HardwareDetails,
    MiaStock,
    AgGridVue,
    TableButtons,
    OrderServices,
    LoaderDialog,
  },
  data: function () {
    return {
      search: '',
      UBID: 0,
      orderServicesDialog: false,
      orderServicesData: null,
      hardwareDialog: false,
      stockDialog: false,
      isNext: false,
      pagination: { rowsPerPage: 10, sortBy: 'dealerID', descending: true },
      headers: [
        {
          text: 'Retrieve',
          value: 'retrieve',
          sortable: false,
        },
        {
          text: 'Order ID',
          sortable: true,
          value: 'orderID',
        },
        {
          text: 'Dealer ID',
          sortable: true,
          value: 'ubDealerID',
        },
        {
          text: 'Dealer Name',
          sortable: true,
          value: 'dealerFullName',
        },
        {
          text: 'Signed Date',
          sortable: true,
          value: 'signedDate',
        },
        {
          text: 'Customer / Company',
          sortable: true,
          value: 'orderString',
        },
        {
          text: 'Status',
          sortable: true,
          value: 'status',
        },
        {
          text: 'Ticket #',
          sortable: true,
          value: 'kayakoConversation',
        },
      ],
      selectedStatus: { status: 'All', value: 'all' },
      statusType: [
        { status: 'Show All', value: 'all' },
        { status: 'Not Yet Ordered', value: 'Not Yet Ordered' },
        { status: 'Pending Fulfillment', value: 'pendingFulfillment' },
        { status: 'Fully Billed', value: 'fullyBilled' },
      ],
      gridOptions: null,
      columnDefs: null,
      defaultColDef: null,
      rowData: null,
      gridApi: null,
      frameworkComponents: null,
      height: '100%',
      width: '100%',
    };
  },
  mounted() {
    let vm = this;
    vm.resetCurrentPage();
    vm.getHardwareOrders();
    // vm.tablePagination();
  },
  beforeMount() {
    let vm = this;
    vm.gridOptions = {};
    vm.columnDefs = [
      {
        headerName: 'Retrieve',
        field: 'actions',
        cellRenderer: 'tableButtons',
        cellRendererParams: {
          clicked: function (param) {
            switch (param.type) {
              case 'hardware':
                vm.showHardware(param);
                break;
              case 'order':
                vm.showOrderSummary(param);
                break;
              case 'services':
              default:
                vm.showOrderServices(param);
                break;
            }
          },
        },
        maxWidth: 360,
      },
      {
        headerName: 'Order ID',
        field: 'orderID',
        sortable: true,
        filter: true,
        maxWidth: 100,
      },
      {
        headerName: 'Dealer ID',
        field: 'ubDealerID',
        sortable: true,
        filter: true,
        maxWidth: 100,
      },
      {
        headerName: 'Dealer Name',
        field: 'dealerFullName',
        sortable: true,
        filter: true,
        maxWidth: 190,
      },
      {
        headerName: 'Signed Date',
        field: 'signedDate',
        sortable: true,
        filter: true,
        valueFormatter: (param) => {
          return vm.$options.filters.formatDate(param.value);
        },
        maxWidth: 130,
      },
      {
        headerName: 'Customer / Company',
        field: 'orderString',
        sortable: true,
        filter: true,
        maxWidth: 429,
      },
      {
        headerName: 'Status',
        field: 'status',
        sortable: true,
        filter: true,
        maxWidth: 150,
      },
      {
        headerName: 'Ticket #',
        field: 'kayakoConversation',
        sortable: true,
        filter: true,
        cellRenderer: function (params) {
          let ticket = params.data.kayakoConversation;
          let template = `<a class="px-0 py-2 kayako" href="https://vonex.kayako.com/agent/conversations/${ticket}"
            target="_blank">${ticket}</a>`;

          if (ticket) return template;
        },
        maxWidth: 130,
      },
    ];
    vm.frameworkComponents = {
      tableButtons: TableButtons,
    };
    vm.defaultColDef = {
      autoHeight: true,
    };
  },
  methods: {
    ...mapOrderActions([
      'getHardwareOrders',
      'getOrderSummary',
      'getHardwareDetails',
      'resetCurrentPage',
      'getDeliveryDetails',
    ]),
    tablePagination() {
      let next = document.querySelectorAll(
        '.v-datatable__actions__range-controls > .v-btn'
      )[3];
      next.addEventListener('click', () => {
        if (next.classList.contains('v-btn--disabled')) {
          this.getHardwareOrders();
        }
      });
    },
    showKayakoConversation(item) {
      window.open(
        `https://vonex.kayako.com/agent/conversations/${item.kayakoConversation}`,
        '_blank'
      );
    },
    showHardware(item) {
      let vm = this;
      vm.getHardwareDetails(item).then((data) => {
        vm.getDeliveryDetails(item.orderID).then((result) => {
          vm.hardwareDialog = true;
        });
      });
    },
    showOrderSummary(item) {
      let vm = this;
      vm.getOrderSummary(item.orderID);
    },
    showOrderServices(item) {
      this.$store.dispatch('orders/listOrders', item.orderID).then((res) => {
        const order = res[0];
        this.orderServicesData = order.orderView;
        this.orderServicesDialog = true;
        this.UBID = item.ubDealerID;
      });
    },
    resetOrderServices() {
      this.orderServicesDialog = false;
    },
    onFirstDataRendered(grid) {
      grid.api.sizeColumnsToFit();
    },
  },
  computed: {
    ...mapGetters('orders', [
      'hardwareOrders',
      'tableLoading',
      'selectedOrder',
    ]),
    filteredHardwareOrders() {
      let vm = this;
      let filterUnsigned = null;
      let minDate = new Date('0001-01-01T00:00:00').toISOString();

      if (!vm.hardwareOrders) return;

      filterUnsigned = vm.hardwareOrders.filter(
        (order) => new Date(order.signedDate).toISOString() != minDate
      );

      if (vm.selectedStatus.value === 'all' || vm.selectedStatus === 'all')
        return filterUnsigned;
      else
        return filterUnsigned.filter(
          (order) => order.status === vm.selectedStatus
        );
    },
  },
  watch: {
    isNext() {
      let vm = this;
    },
    search(val) {
      this.gridOptions.api.setQuickFilter(val);
    },
  },
  filters: {
    formatDate: function (date) {
      if (!date) return null;

      const [year, month, day] = date.substring(0, 10).split('-');
      return `${day}/${month}/${year}`;
    },
    // setStatus: function (status) {
    //   let stat;

    //   switch (status) {
    //     case 2:
    //       stat = "Signed";
    //       break;
    //     case 3:
    //       stat = "Completed";
    //       break;
    //     default:
    //       stat = "";
    //   }

    //   return stat;
    // },
  },
};
</script>

<style>
.orderTable .v-input .v-label,
.orderTable thead th {
  color: #fff !important;
}

.orderTable .theme--light.v-chip:not(.v-chip--active) {
  background-color: #00c2f3 !important;
}

.orderTable
  .theme--light.v-text-field
  > .v-input__control
  > .v-input__slot:before {
  border-color: #fff !important;
}

.padding {
  padding: 10px 0;
}

th {
  background-color: #2f5578;
}

th span,
th i:before {
  color: #fff;
}

.orderTable .v-btn.kayako {
  background-color: #fff !important;
  box-shadow: none !important;
}

.kayako {
  text-decoration: underline;
  color: #2f5578 !important;
  cursor: pointer;
  font-weight: bold;
}

@media screen and (min-width: 767px) {
  .filterSelect {
    width: 150px;
    margin: 0 15px 0 15px !important;
  }
}
</style>
